// extracted by mini-css-extract-plugin
export var container = "_38-0";
export var icon = "_38-1";
export var text = "_38-2";